import { Router } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import { Bounty } from 'src/app/interfaces/Bounty';
import { BountyService } from 'src/app/services/bounty.service';
import { STATUS_COLORS } from '../bounties/view-bounty/view-bounty.component';

@Component({
  selector: 'app-bounties-table',
  templateUrl: './bounties-table.component.html',
  styleUrls: ['./bounties-table.component.scss'],
})
export class BountiesTableComponent implements OnInit {
  @Input() bounties: Bounty[];
  @Input() color = '';

  public statusColors = STATUS_COLORS;

  constructor(
    private bountyService: BountyService,
    private router: Router,
  ) { }

  public typeLabelClass(bounty) {
    return this.bountyService.getBountyLabelClass(bounty);
  }

  // Prevent scrolling on middle mouse down
  public onRowMouseDown(e) {
    if (e.button === 1) {
      return false;
    }
  }
  // On middle mouse button, open link in new tab
  public onRowMouseUp(e, bounty) {
    if (e.which === 2) {
      window.open('/bounties/bounties/' + bounty.id);
    }
  }

  ngOnInit() { }
}
